const escapeHtml = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const getHighlightedText = (text: string, highlight: string) => {
  const safeText = escapeHtml(text);
  const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedHighlight, "gi");

  return safeText.replace(regex, (match) => `<strong>${match}</strong>`);
};
